import axios from 'axios';
import {REQUEST_URL} from '../config/urls';

const requisitar = () => {
  return {
    type: "REQUISITAR_ITEM"
  };
}

const novoItem = (item) => {
  return {
    type: "NOVO_ITEM",
    item
  }
}
const obterTodosContrato = (itens) => {
  return {
    type: "OBTER_TODOS_ITENS",
    itens
  }
}

/*
const obterTodos = (itens) => {
  return {
    type: "OBTER_TODOS_ITENS",
    itens
  }
}

*/
const alterarItem = (item) => {
  return {
    type: "ALTERAR_ITEM",
    item
  }
}

const removerItem = (id) => {
  return {
    type: "REMOVER_ITEM",
    id
  }
}


const erro = (erro) => {
  if (erro.response.data.error.statusCode === 401) {
    axios.defaults.headers.common['Authorization'] = "";
    return {
      type: "LOGOUT"
    }
  }
  return {
    type: "ERRO_ITEM",
    erro
  }
}
export const adicionarItem = (item) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.post(`${REQUEST_URL}/itens`, item).then((response) => {
      dispatch(novoItem(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}
export const atualizarItem = (item) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.put(`${REQUEST_URL}/itens/${item.id}`, item).then((response) => {
      dispatch(alterarItem(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}
export const editarItem = (item, id) => {
  return dispatch => {
    dispatch(requisitar());
    axios.delete(`${REQUEST_URL}/itens/${id}/itensFormando`).then(() => {
      return axios.patch(`${REQUEST_URL}/itens/${id}`, item).then((response) => {
        dispatch(alterarItem(response.data));
      }).catch(error => {
        dispatch(erro(error.response.data.error));
      });
    });
  }
}
// export const obterItensPeloContrato = (contratoId) =>{
//   return dispatch =>{
//     dispatch(requisitar());
//     return axios.get(`${REQUEST_URL}/itens?filter={"where":{"contrato":${contratoId}},"include":["produto","itensFormando"]}`).then((response) => {
//       dispatch(obterTodosContrato(response.data));
//     }).catch(error => {
//       dispatch(erro(error));
//     });
//   }
// }
export const obterItensPeloContrato = (contratoId) =>{
  return dispatch =>{
    dispatch(requisitar());
    return axios.get(`${REQUEST_URL}/itens?filter={"where":{"contrato":${contratoId}},"include":["itensFormando"]}`).then((response) => {
      dispatch(obterTodosContrato(response.data));
    }).catch(error => {
      dispatch(erro(error));
    });
  }
}
export const deletarItem = (id) => {
  return dispatch => {
    dispatch(requisitar());
    axios.delete(`${REQUEST_URL}/itens/${id}/itensFormando`).then(() => {
      return axios.delete(`${REQUEST_URL}/itens/${id}`).then(()=>{
        dispatch(removerItem(id));
      }).catch(error => {
        console.log(error);
        dispatch(erro(error));
      });
    });
  }
}
export const excluirItem = (id) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.delete(`${REQUEST_URL}/itens/${id}`).then(()=>{
      dispatch(removerItem(id));
    }).catch(error => {
      dispatch(erro(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/ItemActions.js